import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { TextField } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";

class MatrixQuestionDescriptionDialog extends Component {
  state = {
    Description: this.props.Description,
    Question_Text: this.props.Question_Text,
    tempDescr: this.props.Description,
    open: false,
  };

  setOpen(val) {
    this.setState({ open: val });
  }

  handleClickOpen = () => {
    this.props.handleMenuClose();
    this.setOpen(true);
  };

  handleClose = () => {
    this.setOpen(false);
    this.setState({ tempDescr: this.state.Description });
  };

  handleConfirm = () => {
    this.setState({ Description: this.state.tempDescr });
    this.props.handleChange(this.state.tempDescr);
    this.setOpen(false);
  };

  handleDescrChange = (e) => {
    this.setState({ tempDescr: e.target.value });
  };

  render() {
    const { open, Question_Text, tempDescr } = this.state;
    return (
      <React.Fragment>
        <MenuItem onClick={this.handleClickOpen}>Edit Description</MenuItem>

        <Dialog
          open={open}
          onClose={this.handleClose}
          maxWidth="sm"
          fullWidth
          aria-labelledby="description-dialog"
        >
          <DialogTitle id="description-dialog">
            {Question_Text} Description
          </DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              size="medium"
              value={tempDescr}
              onChange={this.handleDescrChange}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleConfirm} color="primary">
              Done
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default MatrixQuestionDescriptionDialog;
